<template>
  <div>
    <header-component></header-component>
    <frame-header></frame-header>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2>Frame Collection</h2>
      </div>

      <div class="container g-mt-10 g-mb-10">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
            <p>
              View the Changing Life through Lenses&reg; frame collection
              below. Once ordered, the collection will arrive in 2-3
              weeks and you can begin ordering complete pairs of glasses for
              eligible patients without the need to ship frames to the lab.
            </p>
            <p>
              ✨ New! Our Virtual Try-On tool lets patients see themselves in any of the 45 stylish frame styles — in real time and true to fit.
            </p>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12 text-center"></div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
            <button
              v-on:click="ToggleFrameOrderForm('Order Frame Kit')"
              v-bind:disabled="!Account.isFrameKitAllowed"
              id="PlaceOrder"
              class="btn g-bg-main g-bg-main-blue--hover g-color-white text-uppercase g-rounded-10 mar-right-10"
              style="margin-bottom: 20px;"
            >
              Order Collection
            </button>
            <button
              v-on:click="ToggleFrameOrderForm('Order Individual Frame')"
              :disabled="!Account.isFrameOrderingAllowed"
              class="btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10"
              style="margin-bottom: 20px;"
              v-bind:data-balloon="GetTooltip(Account.isFrameOrderingAllowed)"
              data-balloon-pos="up"
            >
              <span class="text-uppercase">Order Replacement</span>
            </button>
            <button
              @click="goToVirtualTryOn"
              class="btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10"
              style="margin-bottom: 20px;"
            >
              <span class="text-uppercase">Virtual Try-On</span>
            </button>
            <button
              v-on:click="ToggleFrameOrderForm('Order Display Case')"
              v-if="ShowDisplayCaseField"
              :disabled="!Account.isFrameOrderingAllowed"
              class="btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10"
              style="margin-bottom: 20px;"
              v-bind:data-balloon="GetTooltip(Account.isFrameOrderingAllowed)"
              data-balloon-pos="up"
            >
              <span class="text-uppercase">Order Display Case</span>
            </button>
          </div>
          <div
            v-if="!isFrameLoading"
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
          >
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <frame-filters
                @clicked="GetFrames"
                @reset="Reset()"
                :searchValues="searchValues"
              ></frame-filters>
            </div>
          </div>
          <page-loader v-if="isFrameLoading"></page-loader>
        </div>
      </div>
      <!-- <div v-if="!isFrameLoading" v-for="(frameInformation, index) in frameInformationList" :key="index"> -->
      <div
        v-for="(frameInformation, index) in frameInformationList"
        :key="index"
        class="container-fluid g-pb-40"
        v-if="frameInformation.isEVFFrame && !isFrameLoading"
      >
        <div class="row">
          <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-center">
            <frame-order-collection></frame-order-collection>
          </div>
          <div
            v-if="frameInformation.frameList.length > 0"
            class="col-lg-8 col-md-9 col-sm-12 col-xs-12"
          >
            <frame-list :frameList="frameInformation.frameList"></frame-list>
          </div>
          <div
            v-else
            class="col-lg-8 col-md-9 col-sm-12 col-xs-12 center div-spacing-top"
          >
            <p class="g-font-size-20 g-color-main">
              Your search returned no results
            </p>
          </div>
          <div
            v-if="!Account.isFrameKitAllowed"
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
          >
            <p class="error-message">
              You cannot place an order for a frame collection at this time
            </p>
          </div>
        </div>
        <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center" v-if="this.CountFrames(false) > 0">
                        <hr>
                    </div> -->
        <div
          v-if="!isFrameLoading"
          class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
        >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"></div>
        </div>
        <page-loader v-if="isFrameLoading"></page-loader>
      </div>
      <div
        class="container-fluid g-pb-40"
        v-if="
          frameInformationList.filter((a) => !a.isEVFFrame).length > 0 &&
          !isFrameLoading
        "
      >
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
            <hr />
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
            <h1>Additional Frames</h1>
            <div class="row">
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"></div>
              <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <p>
                  These frames are not part of the Changing Life through Lenses™
                  frame collection, but are available for you to select as a
                  Frame and Lens order on the Order page. You cannot order a
                  frame collection for these
                  additional frames.
                </p>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"></div>
            </div>
          </div>
        </div>
      </div>
      <jotform-modal v-if="showJotForm" :Account="Account" formID="220894492083058" @closeJotForm="CloseModal"></jotform-modal>
      <!-- <frame-order-form
        v-if="showJotForm"
        @closeWufoo="ToggleFrameOrderForm"
        :Account="Account"
        :orderType="orderType"
      ></frame-order-form> -->
      <div
        v-for="(frameInformation, index) in frameInformationList.filter(
          (a) => !a.isEVFFrame
        )"
        :key="index"
        class="container-fluid g-pb-40"
        v-if="!frameInformation.isEVFFrame && !isFrameLoading"
      >
        <!-- <div v-if="this.CountFrames(false) > 0 && !isFrameLoading" class="container-fluid g-pb-40"> -->
        <div class="row">
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
            v-if="index != 0"
          >
            <hr />
          </div>
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
            v-if="frameInformation.catalogName"
          >
            <h2>{{ ConvertToTitleCase(frameInformation.catalogName) }}</h2>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-center"></div>
          <div
            v-if="frameInformation.frameList.length > 0"
            class="col-lg-8 col-md-9 col-sm-12 col-xs-12"
          >
            <frame-list :frameList="frameInformation.frameList"></frame-list>
          </div>
          <!--<div v-if="true" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">-->
          <!--<p class="error-message">You cannot place an order for a frame collection at this time</p>-->
          <!--</div>-->
        </div>
      </div>
      <!-- </div> -->
    </div>
    <footer-component></footer-component>

    <div v-if="isWufooModalShown">
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-md">
            <div class="modal-content modal-edit-bg">
              <div class="modal-body">
                <div class="row">
                  <div
                    class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
                  >
                    <div class="close_btn" v-on:click="CloseModal()"></div>
                    <br />
                    <div class="row">
                      <div class="" style="width: 100%; padding: 20px;">
                        <!-- Fill out my <a href="https://evf.wufoo.com/forms/k1vh58nv1osavlv">online form</a>. -->
                        <div id="wufoo-k1vh58nv1osavlv"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isPlaceOrder">
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-md">
            <div class="modal-content modal-edit-bg">
              <div class="modal-body">
                <div class="row">
                  <frame-shipping-billing
                    :Account="Account"
                    @exitModal="CloseModal"
                  ></frame-shipping-billing>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import PageLoader from "@/components/shared/PageLoader";
import FrameHeader from "@/components/portal/frameResources/frameComponents/FrameHeader";
import FrameFilters from "@/components/portal/frameResources/frameComponents/FrameFilters";
import FrameOrderCollection from "@/components/portal/frameResources/frameComponents/FrameOrderCollection";
import FrameList from "@/components/portal/frameResources/frameComponents/FrameList";
import FrameShippingBilling from "@/components/portal/frameResources/frameComponents/FrameShippingBilling";
import FrameOrderForm from "@/components/shared/FrameOrderForm";
import JotformModal from '../../shared/JotformModal.vue';

export default {
  components: {
    FrameHeader,
    HeaderComponent,
    FooterComponent,
    FrameList,
    FrameFilters,
    /*FrameOrderCollection,*/ PageLoader,
    FrameShippingBilling,
    //FrameOrderForm,
    JotformModal,
  },
  data() {
    return {
      frameInformationList: [],
      frameList: [],
      BillingAddress: { isBillingDifferent: true },
      isPlaceOrder: false,
      ShowDisplayCaseField: false,
      showJotForm: false,
      searchValues: {
        FirstLoad: true,
        Color: [],
        FrameType: [],
        MinRange: 35,
        MaxRange: 70,
      },
      isFrameLoading: true,
      Account: {},
      orderType: null,
      showMessageOrdered: false,
      isWufooModalShown: false,
    };
  },
  methods: {
    Reset() {
      this.searchValues = {
        FirstLoad: true,
        Color: [],
        FrameType: [],
        MinRange: 35,
        MaxRange: 70,
      };
      this.GetFrames();
    },
    GetFrames() {
      var _this = this;
      this.isFrameLoading = true;
      axios
        .post("/frame/SearchFrame", this.searchValues, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        })
        .then(function (response) {
          _this.isFrameLoading = false;
          _this.frameInformationList = response.data.raw.frameInformationList;
          for (var j = 0; j < _this.frameInformationList.length; j++) {
            for (
              var i = 0;
              i < _this.frameInformationList[j].frameList.length;
              i++
            ) {
              _this.frameInformationList[j].frameList[i].swiperOptionSingle = {
                navigation: {
                  prevEl: "#previousFrame" + j + i,
                  nextEl: "#nextFrame-gallery-prev" + j + i,
                },
              };
              _this.frameInformationList[j].frameList[i].idList = {
                prevEl: "previousFrame" + j + i,
                nextEl: "nextFrame-gallery-prev" + j + i,
              };
            }
          }
        })
        .catch(function (error) {
          _this.isFrameLoading = false;
          console.log(error);
          _this.$router.push({ name: "Error" });
        });
    },
    PlaceOrder() {
      if (this.Account.isFrameKitAllowed) {
        /*
                    var _this = this;
                    axios.post('/frame/SaveChanges',  this.searchValues,{headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                    .then(function (response) {
                        _this.isPlaceOrder = true;
                        _this.Account.isFrameKitAllowedisFrameKitAllowed
                    })
                    .catch(function (error) {
                       _this.$router.push({name: 'Error'});
                    });*/
        this.isPlaceOrder = true;
      } else {
        this.showMessageOrdered = true;
      }
    },
    GetAccountValues() {
      var _this = this;
      this.isAccountLoading = true;
      axios
        .get("/Account/Self", {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        })
        .then(function (response) {
          _this.Account = response.data.raw;
          localStorage.setItem(
            "customUserPermissionFlag",
            _this.Account.customUserPermissionFlag
          );
          _this.ShowDisplayCaseField = _this.Account.customUserPermissionFlag.includes(
            "Order Display Case Only"
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ToggleFrameOrderForm(passOrderType) {
      this.orderType = passOrderType;
      this.Account.orderType = passOrderType;
      this.showJotForm = !this.showJotForm;
      if (this.showJotForm) {
        document.body.classList.add("body-overflow");
      } else {
        document.body.classList.remove("body-overflow");
      }
    },
    CloseModal() {
      document.body.classList.remove("body-overflow");
      //this.isWufooModalShown = false;
        this.showJotForm = false;
        if(this.showJotForm){
            document.body.classList.add("body-overflow");
        }
        else{
            document.body.classList.remove("body-overflow");
        }
      this.isPlaceOrder = false;
    },
    GetTooltip(param) {
      if (param) return false;
      else return "Frame replacements are unavailable at this time";
    },
    RemoveNullImages(images) {
      return images.filter((e) => e != "NULL");
    },
    CountFrames(evfFrames) {
      var retValue = true;
      var arrEVF = [];
      var arrNonEVF = [];
      // this.frameList.forEach(frame => {
      //     frame.isEVFFrame.forEach(f => {
      //         if(f == true){
      //             arrEVF.push(frame);
      //         }
      //         else
      //           arrNonEVF.push(frame);
      //     });
      // });
      if (evfFrames == true) return arrEVF.length;
      else {
        return arrNonEVF.length;
      }
    },
    goToVirtualTryOn() {
      window.location.href = "https://onesightframes.org/";
    },
  },
  created() {
    this.GetFrames();
    this.GetAccountValues();
    localStorage.setItem("is-active", "frame");
    this.frameInformationList.forEach((frameInfo) => {
      frameInfo.frameList.forEach((frame) => {
        frame.imageUrl = this.RemoveNullImages(frame.imageUrl);
      });
    });
  },
};
</script>



// WEBPACK FOOTER //
// FramesCenter.vue?3de892b4